<template>
    <FieldItem
        :id="id"
        :label="$t(fieldConfig.label)"
    >
        <template slot="label">
            <span>{{ $t(fieldConfig.label) }}({{ $t('Search.labels.threshold') }})</span>
            <ElPopover
                :visible-arrow="false"
                :width="366"
                placement="right"
                trigger="hover"
                popper-class="bio-search-setting__popover"
            >
                <PreferencesPropver :type="'evalue'" />
                <PtIcon
                    slot="reference"
                    icon="SolidInfo"
                />
            </ElPopover>
        </template>
        <ElSelect
            v-model="fieldValue"
            class="search-preference__select"
            size="small"
            :placeholder="$t(fieldConfig.label)"
            @change="syncChange"
        >
            <ElOption
                v-for="option in evalueOptionsFinal"
                :key="option.value"
                :label="option.label"
                :value="option.value"
            />
        </ElSelect>
    </FieldItem>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import Popover from 'element-ui/lib/popover';
import PtIcon from '@patsnap-biz/icon';
import FieldItem from '../components/FieldItem.vue';
import { FieldItemMixin } from './mixins';
import PreferencesPropver from '../explanations/PreferencesPropver.vue';
import { evalueOptions } from '../constants/constantConfig';
import { SEARCH_TYPES } from '../constants';

export default {
    components: {
        PreferencesPropver,
        FieldItem,
        ElPopover: Popover,
        PtIcon,
        ElSelect: Select,
        ElOption: Option,
    },
    mixins: [FieldItemMixin],
    inject: ['store'],
    props: {
        fieldName: {
            type: String,
            default: 'evalue',
        },
    },
    computed: {
        evalueOptionsFinal() {
            if (this.store.transferredSearchType === SEARCH_TYPES.short) {
                return evalueOptions.filter((x) => x.value >= 0.1);
            }
            return evalueOptions;
        },
    },
};
</script>
